<template>
  <su-page>
    <el-row class="mt30" slot="content">
      <el-table :data="tableData" :header-cell-style="{backgroundColor:'#F3F4F8'}">
        <el-table-column prop="name" label="姓名" min-width="80"></el-table-column>
        <el-table-column prop="create_time" label="报名时间" min-width="160"></el-table-column>
        <el-table-column label="考场名宇" min-width="160">
          <template slot-scope="scope">
            {{ scope.row.eaddress.firm }}
            <!--（{{ scope.row.eaddress.address }}）-->
          </template>
        </el-table-column>
        <el-table-column prop="pay_price" label="报名费" width="70"></el-table-column>
        <el-table-column prop="status" label="考场状态" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0">未开始</span>
            <span v-else-if="scope.row.status === 1">进行中</span>
            <span v-else-if="scope.row.status === 2">已结束</span>
          </template>
        </el-table-column>
        <el-table-column prop="pay_status" label="缴费状态" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.pay_status === 0">待支付</span>
            <span v-else>已支付</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button
                v-if="scope.row.pay_status == 0"
                size="mini"
                type="warning"
                @click="payTheFees(scope.row)">
              缴费
            </el-button>
            <el-button
                size="mini"
                type="primary"
                @click="registrationInformation(scope.row)">
              报名信息
            </el-button>
            <el-button
                v-if="scope.row.exam_image"
                size="mini"
                type="success"
                @click="getTicket(scope.row)">
              准考证
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="报名信息" :visible.sync="registrationDetailsVisible" :width="dialogWidth">
        <el-row :gutter="20" class="message cl333">
          <el-col :span="span">
            <div class="message-text">
              <div class="name">姓名:</div>
              {{ registrationDetails.name || '' }}
            </div>
            <div class="message-text">
              <div class="name">性别:</div>
              {{ registrationDetails.sex == 1 ? '男' : '女' }}
            </div>
            <div class="message-text">
              <div class="name">民族:</div>
              {{ registrationDetails.nation || '' }}
            </div>
            <div class="message-text">
              <div class="name">证件类型:</div>
              {{ registrationDetails.cert_type || '' }}
            </div>
            <div class="message-text">
              <div class="name">出生日期:</div>
              {{ registrationDetails.birthday || '' }}
            </div>
            <div class="message-text">
              <div class="name">身份证号:</div>
              {{ registrationDetails.cert_no || '' }}
            </div>
          </el-col>
          <el-col :span="span">
            <div class="message-text">
              图片：
              <img height="140px" :src="registrationDetails.picture" alt="">
            </div>
            <div class="message-text">年龄：{{ registrationDetails.age }}</div>
          </el-col>
          <el-col :span="24">
            <h3 class="message-text">{{ registrationDetails.type == 1 ? '补考' : '初考' }}</h3>
          </el-col>
          <el-col :span="span">
            <div class="message-text">
              <div class="name">所在考点:</div>
              {{
                registrationDetails.eaddress ? registrationDetails.eaddress.firm : ''
              }}
            </div>
            <div class="message-text">
              <div class="name">最高学历:</div>
              {{ registrationDetails.education || '' }}
            </div>
            <div class="message-text">
              <div class="name">专业:</div>
              {{ registrationDetails.personal || '' }}
            </div>
            <div class="message-text">
              <div class="name">所学外语及程度:</div>
              {{ registrationDetails.foreign || '' }}
            </div>
            <div class="message-text" v-if="registrationDetails.type == 0">
              <div class="name">国际中文相关证书:</div>
              {{ registrationDetails.is_teacher || '' }}
            </div>
            <div class="message-text">
              <div class="name">通讯方式:</div>
              {{ registrationDetails.eaddress ? registrationDetails.eaddress.mobile : '无' }}
            </div>
            <div class="message-text">
              <div class="name">通讯地址:</div>
              {{ registrationDetails.eaddress ? registrationDetails.eaddress.address : '无' }}
            </div>
            <div class="message-text">
              <div class="name">备注:</div>
              {{ registrationDetails.remark || '无' }}
            </div>
            <div class="message-text"
                 v-if="registrationDetails.mandarin && registrationDetails.mandarin != '二级乙等或以上均无'">
              普通话证书图片：
              <img width="130px" height="130px" :src="registrationDetails.man_cert" alt=""/>
            </div>
            <div class="message-text"
                 v-if="registrationDetails.is_teacher && registrationDetails.is_teacher != '无' && registrationDetails.type == 0">
              国际中文相关证书图片：
              <img width="130px" height="130px" :src="registrationDetails.teacher_cert" alt=""/>
            </div>
          </el-col>
          <el-col :span="span">
            <div class="message-text">
              <div class="name">考试时间:</div>
              {{ registrationDetails.exam_time || '' }}
            </div>
            <div class="message-text">
              <div class="name">毕业/就读院校:</div>
              {{ registrationDetails.school || '' }}
            </div>
            <div class="message-text">
              <div class="name">普通话等级:</div>
              {{ registrationDetails.mandarin || '' }}
            </div>
            <div class="message-text">
              <div class="name">微信号:</div>
              {{ registrationDetails.wx_account || '' }}
            </div>
            <div class="message-text">
              <div class="name"> 缴费方式:</div>
              {{ registrationDetails.pay_type == 0 ? '微信' : '支付宝' }}
            </div>
            <div class="message-text">
              <div class="name">Emall:</div>
              {{ registrationDetails.email || '' }}
            </div>
            <div class="message-text">
              <div class="name">手机号:</div>
              {{ registrationDetails.mobile || '' }}
            </div>
            <div class="message-text" v-if="registrationDetails.foreign && registrationDetails.foreign != '以上均无'">
              外语证书图片：
              <img width="130px" height="130px" :src="registrationDetails.foreign_cert" alt=""/>
            </div>
          </el-col>
        </el-row>
      </el-dialog>
      <!-- 微信支付弹框 -->
      <el-dialog
          :visible.sync="buy_code"
          title="微信支付"
          @close="buy_close"
          :close-on-click-modal="false"
          width="350px"
          center>
        <div class="mb20 align-center">请用微信扫码支付</div>
        <div class="flex ju-cn mb20">
          <div id="qrcode" ref="qrcode"></div>
        </div>
      </el-dialog>
      <div ref="alipayWap"/>
    </el-row>
  </su-page>
</template>
<script>

import {baoList, check_status, getRegistrationDetail, submit} from "@/api/api";
import QRCode from "qrcodejs2"; // 引入qrcode

export default {
  name: "myRegistration",
  data() {
    return {
      tableData: [],
      registrationDetailsVisible: false,
      registrationDetails: {}, // 报名信息
      //给弹出框设置宽度，判断当前是移动端还是pc端
      dialogWidth: document.body.clientWidth < 750 ? '90%' : '60%',
      span: document.body.clientWidth < 750 ? 24 : 12,
      buy_code: false, // 支付弹框
    }
  },
  created() {

  },
  mounted() {
    this.baoList()
  },
  methods: {
    // 报名列表
    baoList() {
      baoList().then(res => {
        if (res.status === 200) {
          this.tableData = res.data.data
        }
      })
    },
    // 报名信息
    registrationInformation(item) {
      getRegistrationDetail({
        bao_id: item.id
      }).then(res => {
        if (res.status === 200) {
          this.registrationDetails = res.data
          this.registrationDetailsVisible = true
        }
      })
    },
    // 缴费
    payTheFees(e) {
      submit({
        pay_type: e.pay_type == 0 ? 'wechat' : 'alipay',
        bao_id: e.id
      }).then(res => {
        if (res.status === 200) {
          if (e.pay_type == 0) { //微信
            this.buy(e.id,res.data)
          } else { //支付宝
            const div = document.createElement('alipayWap') // 创建一个div
            /* 下面的data.content就是后台返回接收到的数据 */
            div.innerHTML = res.data.content // 将后台返回的html代码添加到div中
            document.body.appendChild(div) // 将div添加到body中
            document.forms[0].submit() // 提交表单
          }
        }
      })
    },
    // 购买
    async buy(id,e) {
      //弹出购买二维码
      this.buy_code = true
      this.timer = setInterval(() => {
        check_status({
          order_id: id
        }).then(res => {
          if (res.status === 200) {
            if (res.data.pay_status){
              this.buy_code = false
              this.$message.success('购买成功')
              // 购买成功后的相关操作
              this.baoList()
              this.buy_close()
            }
          } else {
            this.$message.error(res.msg)
          }
        })
      }, 2000)
      //使用nextTick确保在弹框显示前二维码数据渲染，不加的话可能报错获取不到qrcode元素
      this.$nextTick(() => {
        this.qrcode = new QRCode("qrcode", {
          width: 150,//二维码宽度
          height: 150,//二维码高度
          text: e.code_url,//调用微信支付接口返回的微信特殊链接：例如"weixin://wxpay/bizpayurl?pr=uDKsQ4E00"
          colorDark: "#000",//颜色配置
          colorLight: "#fff",
        });
      })
    },
    // 购买课程弹框关闭
    buy_close() {
      clearInterval(this.timer) // 清除定时器
      this.$refs.qrcode.innerHTML = "";//清空渲染的二维码
      this.timer = null // 清除定时器
    },
    //准考证
    getTicket(e) {
      //下载图片
      window.open(e.exam_image)
    }
  }
}
</script>


<style scoped lang="scss">
.message {
  &-text {
    margin-bottom: 15px;
    display: flex;

    .name {
      min-width: 80px;
      margin-right: 5px;
    }
  }
}
</style>
